export interface FeedbackSubmission {
  scope: {application: string; component: string};
  rating?: number;
  comment?: string;
  userTags?: string[];
  metadata?: Record<string, unknown>;
}

export interface FeedbackConfig extends FeedbackSubmission {
  titleText?: string;
  commentText?: string;
  suggestedTags?: string[];
  preSelectedTag?: string;
}

export interface FeedbackResponsePayload {
  feedbackId: string;
  userId: string;
  scope: {application: string; component: string};
  createdDate: string;
  updatedDate: string;
  comment?: string;
  rating?: number;
  userTags?: string[];
  metadata?: Record<string, unknown>;
}
